import { FC } from 'react';

import styles from './FeatureLabels.css';
import { FeatureLabel, IFeatureLabel } from './components/FeatureLabel';

interface IFeatureLabelsProps {
  items: IFeatureLabel[];
}

export const FeatureLabels: FC<IFeatureLabelsProps> = ({ items }) => {
  return (
    <div className={styles['container']}>
      {items.map((item, index) => (
        <FeatureLabel {...item} key={index} />
      ))}
    </div>
  );
};
